import type { RegisteredRouter } from "@tanstack/react-router";
import type { RouteToPath } from "@tanstack/router-core";

export const INVITATION_LINK_TAB = {
  DETAILS: "details",
  ACCESS: "access",
  SUBSCRIPTION: "subscription",
  PAYWALLS: "paywalls",
} as const;

export type InvitationLinkTab =
  (typeof INVITATION_LINK_TAB)[keyof typeof INVITATION_LINK_TAB];

export const INVITATION_LINK_TABS: readonly InvitationLinkTab[] =
  Object.values(INVITATION_LINK_TAB);

type NewInvitationLinkTabPath<T extends InvitationLinkTab = InvitationLinkTab> =
  Extract<RouteToPath<RegisteredRouter>, `/settings/invitation_links/new/${T}`>;

type NewInvitationLinkTabPaths = {
  [Tab in InvitationLinkTab]: NewInvitationLinkTabPath<Tab>;
};

export const NEW_INVITATION_LINK_TAB_PATHS = {
  [INVITATION_LINK_TAB.DETAILS]: "/settings/invitation_links/new/details",
  [INVITATION_LINK_TAB.ACCESS]: "/settings/invitation_links/new/access",
  [INVITATION_LINK_TAB.SUBSCRIPTION]:
    "/settings/invitation_links/new/subscription",
  [INVITATION_LINK_TAB.PAYWALLS]: "/settings/invitation_links/new/paywalls",
} as const satisfies NewInvitationLinkTabPaths;

type EditInvitationLinkTabPath<
  T extends InvitationLinkTab = InvitationLinkTab,
> = Extract<
  RouteToPath<RegisteredRouter>,
  `/settings/invitation_links/$id/edit/${T}`
>;

type EditInvitationLinkTabPaths = {
  [Tab in InvitationLinkTab]: EditInvitationLinkTabPath<Tab>;
};

export const EDIT_INVITATION_LINK_TAB_PATHS = {
  [INVITATION_LINK_TAB.DETAILS]: "/settings/invitation_links/$id/edit/details",
  [INVITATION_LINK_TAB.ACCESS]: "/settings/invitation_links/$id/edit/access",
  [INVITATION_LINK_TAB.SUBSCRIPTION]:
    "/settings/invitation_links/$id/edit/subscription",
  [INVITATION_LINK_TAB.PAYWALLS]:
    "/settings/invitation_links/$id/edit/paywalls",
} as const satisfies EditInvitationLinkTabPaths;

export const isInvitationLinkTab = (tab: string): tab is InvitationLinkTab =>
  INVITATION_LINK_TABS.includes(tab as InvitationLinkTab);
